const selectIpWhitelist = (state) => state.ipWhitelist;
export const selectIpWhitelistData = (state) => selectIpWhitelist(state).data;
export const selectIpWhitelistTotal = (state) => selectIpWhitelist(state).total;
